import styled from 'styled-components';
import { FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 216px;
    margin-right: 216px;
    width: 100%;
    margin-bottom: 360px;
    @media screen and (max-width: 1700px){
        margin: 0 105px;
    }
    @media screen and (max-width: 1200px){
        margin: 0 48px;
    }
    @media screen and (max-width: 990px){
        margin: 0 34px;
    }
    @media screen and (max-width: 560px){
        margin: 0 16px;
    }
`;

export const Title = styled.div`
    ${FONTS.H2};
    margin-top: 125px;
    @media screen and (max-width: 1200px){
        margin-top: 97px;
    }
    @media screen and (max-width: 560px){
        ${FONTS.H3};
    }
`;

export const Text = styled.div`
    ${FONTS.L};
    margin-top: 18px;
    @media screen and (max-width: 1200px){
        ${FONTS.S};
        max-width: 800px;
    }
`;

export const StepsBlock = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    margin-bottom: -360px;
    @media screen and (max-width: 1200px){
        margin-top: 80px;
    }
    @media screen and (max-width: 990px){
        margin-top: 40px;
    }
`;

export const BlockTitle = styled.div`
    ${FONTS.H1};
    margin-bottom: 60px;
    @media screen and (max-width: 1200px){
        margin-bottom: 30px;
        ${FONTS.H3};
    }
`;
